import { EnumEstadoFichero, EnumGrupoDocumento, EnumTipoDocumento } from '../../../../api'
import { DataTableActionConfiguration } from '../../../../model'

export interface FileModel {
  id?: number
  documentType?: EnumTipoDocumento
  description?: string
  documentDate?: Date
  endDate?: Date
  cominicationDate?: Date
  idTransmitterSubjet?: number
  codTransmitterSubject?: string
  transmitterSubject?: string
  idDestinationSubject?: number
  codDestinationSubject?: string
  destinationSubject?: string
  url?: string
  urlLog?: string
  state?: EnumEstadoFichero
  documentGroup?: EnumGrupoDocumento
  dischargedDate?: string
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
  objectionsActionsConfiguration?: Array<DataTableActionConfiguration>
  objectionsActions?: any
  isFileOk?: boolean
  isErrorLog?: boolean
}

export enum UploadedFileStates {
  ERROR,
  QUEUED,
  UNSUPPORTED
}

export interface UploadedFileResume {
  fileName: string
  state: UploadedFileStates
}

export interface FileQueued {
  fileName: string
  queued: boolean
}
